export default [
    {
        a: 'a1',
        b: 'b1',
        c: 'c1',
        abc: 'a1 + b1 + c1',
        list: [
            {
                e: 'e1',
                f: 'f1',
                g: 'g1',
                h: 'h1',
                list: [
                    {
                        i: 'i1',
                        j: 'j1'
                    },
                    {
                        i: 'i1',
                        j: 'j1'
                    },
                    {
                        i: 'i1',
                        j: 'j1'
                    },
                    {
                        i: 'i1',
                        j: 'j1'
                    }
                ]
            },
            {
                e: 'e11',
                f: 'f11',
                g: 'g11',
                h: 'h11',
                list: [
                    {
                        i: 'i11',
                        j: 'j11'
                    },
                    {
                        i: 'i11',
                        j: 'j11'
                    }
                ]
            }
        ]
    },
    {
        a: 'a2',
        b: 'b2',
        c: 'c2',
        abc: 'a2 + b2 + c2',
        list: [
            {
                e: 'e2',
                f: 'f2',
                g: 'g2',
                h: 'h2',
                list: [
                    {
                        i: 'i2',
                        j: 'j2'
                    },
                    {
                        i: 'i2',
                        j: 'j2'
                    },
                    {
                        i: 'i2',
                        j: 'j2'
                    },
                    {
                        i: 'i2',
                        j: 'j2'
                    }
                ]
            },
            {
                e: 'e22',
                f: 'f22',
                g: 'g22',
                h: 'h22',
                list: [
                    {
                        i: 'i22',
                        j: 'j22'
                    },
                    {
                        i: 'i22',
                        j: 'j22'
                    },
                    {
                        i: 'i22',
                        j: 'j22'
                    },
                    {
                        i: 'i22',
                        j: 'j22'
                    }
                ]
            }
        ]
    }
]
